"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _letterOfAttorney = require("./letterOfAttorney");
var _default = exports["default"] = {
  sendLetterOfAttorney: _letterOfAttorney.sendLetterOfAttorney
};
module.exports = exports["default"];